import * as React from 'react';

import { Feedback } from '../renderForQuestions/feedback';
import staticStrings from '../../libs/speech/staticStrings.json';

const renderOptions = (next, answers) => {
  const components = answers.map(answer => (
    <button className="button lesson-multiple-choice-button" key={answer.key} onClick={next} type="button">
      {answer.text}
    </button>
  )
  );
  return <div className="lesson-multiple-choice">{components}</div>
}

const MultipleChoice = ({ prompt, answers, next, showTranslation, translate, languageLocale }) => (
  <section className="student-container">
    <div className="content multiple-choice-content">
      {prompt}
      <Feedback
        feedbackText={staticStrings['connect.multipleChoiceInstructions']}
        feedbackType="override"
        key="multiple-choice"
        languageLocale={languageLocale}
        showTranslation={showTranslation}
        translate={translate}
      />
      {renderOptions(next, answers)}
    </div>
  </section>
)

export { MultipleChoice };

